import { authenticatedApiClient } from './axios';
import { Member, GlobalMember } from '@cobu/types';

export const groupMembersService = {
  /**
   * Fetch building residents (global chat members)
   */
  async getBuildingMembers(buildingId: string): Promise<GlobalMember[]> {
    const data: any = await authenticatedApiClient.get(`/v2/building/${buildingId}/users`);

    let members: any[] = [];
    if (Array.isArray(data)) {
      members = data;
    } else if (data && Array.isArray(data.data)) {
      members = data.data;
    } else if (data && typeof data === 'object') {
      if (Array.isArray((data as any).users)) {
        members = (data as any).users;
      } else if (Array.isArray((data as any).members)) {
        members = (data as any).members;
      } else {
        const values = Object.values(data);
        const arrayValue = values.find((val) => Array.isArray(val)) as any[] | undefined;
        members = arrayValue || [];
      }
    }

    return members.map((member: any) => ({
      uuid: member.uuid,
      firstName: member.firstName || member.user?.firstName || '',
      lastName: member.lastName || member.user?.lastName || '',
      displayName: member.displayName || member.user?.displayName || '',
      email: member.user?.email,
      profileImage: member.profileImage || member.user?.profileImage,
      deactivated: member.deactivated || member.user?.deactivated || false,
      blocked: member.blocked || member.user?.blocked || false,
      role: member.role,
    })) as GlobalMember[];
  },

  /**
   * Fetch group members (active only)
   */
  async getGroupMembers(groupId: string): Promise<Member[]> {
    const data: any = await authenticatedApiClient.get(`/groupmember`, {
      params: { group: groupId, active: true },
    });
    return (data?.data ?? data ?? []) as Member[];
  },
};

export default groupMembersService;


